type VideroMarkProps = {
  className?: string;
};

export default function VideroMark({ className }: VideroMarkProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.75 5.75H11.25L8 18.25H1.5L4.75 5.75Z"
        fill="currentColor"
        fillOpacity="0.18"
      />
      <path
        d="M12.75 5.75H19.25L16 18.25H9.5L12.75 5.75Z"
        fill="currentColor"
        fillOpacity="0.38"
      />
      <path
        d="M5 5.5H11.5L8.25 18.5H1.75L5 5.5Z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinejoin="round"
      />
      <path
        d="M13 5.5H19.5L16.25 18.5H9.75L13 5.5Z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinejoin="round"
      />
      <path
        d="M8.625 18.5L12.375 5.5"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
      />
    </svg>
  );
}
